// @flow

import React, { useState } from 'react'
import type { Node } from 'react'

import NewMailReplyForm from '../../../components/Mail/NewMailReplyForm'

type Props = {|
  isMass: boolean,
  isSending: boolean,
  onCreate: Object => void,
  onDocsEnabled?: boolean => void,
  onToggleMass: boolean => void,
  thread: Object,
|}

const NewMailThreadCreate = (props: Props): Node => {
  const { thread, isMass, isSending, files } = props

  const [selectedFiles, setSelectedFiles] = useState([])

  const handleSelectFiles = files => {
    const selectedIds = selectedFiles.map(f => f.id)

    const newFiles = files.filter(file => !selectedIds.includes(file.id))

    setSelectedFiles(selectedFiles.concat(newFiles))
  }

  const removeExternalFile = id =>
    setSelectedFiles(
      selectedFiles.filter(selectedFile => selectedFile.id !== id)
    )

  return (
    <section className='unit unit--default'>
      <NewMailReplyForm
        {...thread}
        withProviders
        showAddButton
        isMass={isMass}
        isSending={isSending}
        files={files}
        externalFiles={selectedFiles.map(file => ({
          ...file,
          isExternalFile: true,
        }))}
        removeExternalFile={removeExternalFile}
        setSelectedFiles={handleSelectFiles}
        onDocsEnabled={props.onDocsEnabled}
        onSave={props.onCreate}
        onToggleMass={props.onToggleMass}
      />
    </section>
  )
}

export default NewMailThreadCreate
